import {createSlice} from "@reduxjs/toolkit";
import {json} from "../../lib/appfuse-react/core/json";

const name = 'setting';

const initialState = {
    certificationStandards: []
};

const slice = createSlice({
    name,
    initialState,
    reducers: {
        setCertificationStandards(state, action) {
            state.certificationStandards = json.toJSON(action.payload);
        }
    }
});

export const { setCertificationStandards } = slice.actions;
const {reducer} = slice;

export const selectCertificationStandards = state => json.fromJSON(state[name].certificationStandards);

const utilReducer = reducer;
export default utilReducer;